// extracted by mini-css-extract-plugin
module.exports = {"stats":"MonsterStats_stats__12Vs0","bold":"MonsterStats_bold__1fZoX"};